import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardContent } from '@guildeducationinc/recess';
import { AdminTopNav } from '@src/components/Admin/AdminTopNav';
import { EditClientConfig } from '@src/components/Admin/EditClientConfig';
import { useClientIdParam } from '@src/hooks/useClientIdParam';
import { useClientConfig, useLocale } from 'pe-core-frontend';
export const LocaleSettings = () => {
    const { t } = useLocale();
    const clientId = useClientIdParam() || 0;
    const { clientConfig } = useClientConfig({ clientId });
    if (!clientConfig)
        return null;
    return (_jsxs("div", { children: [_jsx(AdminTopNav, { title: t('Locales') }), _jsx("div", { children: _jsx(Card, { children: _jsx(CardContent, { children: _jsx(EditClientConfig, { clientConfig: clientConfig }) }) }) })] }));
};
